import { makeApiRequest } from '../Api';

export const DEFAULT_JOBS_PAGE_SIZE = 25;

export const normalizeJobsListResponse = (data) => {
	if (Array.isArray(data)) {
		return {
			results: data,
			count: data.length,
			next: null,
			previous: null,
		};
	}
	return {
		results: data?.results || [],
		count: data?.count ?? 0,
		next: data?.next ?? null,
		previous: data?.previous ?? null,
	};
};

export const buildJobsListParams = ({
	page = 1,
	pageSize = DEFAULT_JOBS_PAGE_SIZE,
	search,
	pipeline,
	bidStatuses,
	jobStatuses,
	customers,
	sort,
	ordering,
} = {}) => {
	const params = {
		page,
		page_size: pageSize,
	};

	const trimmedSearch = search?.trim();
	if (trimmedSearch) {
		params.search = trimmedSearch;
	}
	if (pipeline && pipeline !== 'all') {
		params.pipeline = pipeline;
	}
	if (bidStatuses?.length) {
		params.bid_status = bidStatuses.join(',');
	}
	if (jobStatuses?.length) {
		params.job_status = jobStatuses.join(',');
	}
	if (customers?.length) {
		params.customer = customers.join(',');
	}
	if (sort) {
		params.sort = sort;
	}
	if (ordering) {
		params.ordering = ordering;
	}

	return params;
};

export const fetchJobsList = async (params = {}) => {
	const data = await makeApiRequest('GET', '/jobs/', null, params);
	return normalizeJobsListResponse(data);
};

/** Page through the API for consumers that need a full job list (e.g. assignment picker). */
export const fetchAllJobsList = async (params = {}) => {
	const pageSize = 100;
	let page = 1;
	let all = [];
	let count = Infinity;

	while (all.length < count) {
		const {
			results,
			count: total,
			next,
		} = await fetchJobsList({
			...params,
			page,
			page_size: pageSize,
		});
		count = total;
		all = all.concat(results);
		if (!next) {
			break;
		}
		page += 1;
	}

	return all;
};
